import { getSubcategoryInfo } from '../config/subcategoryMapping';
import Image from 'next/image';
/**
 * SubcategoryIcon component for displaying subcategory icons with consistent styling
 * @param {Object} props - Component props
 * @param {string} props.subcategoryName - The name of the subcategory
 * @param {string} props.size - Size of the icon (sm, md, lg, xl)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {boolean} props.showTooltip - Whether to show tooltip on hover
 * @param {boolean} props.showDuration - Whether to show duration badge
 * @param {boolean} props.showPopular - Whether to show popular badge
 * @returns {JSX.Element} Subcategory icon component
 */

const SubcategoryIcon = ({
    subcategoryName,
    size = 'md',
    className = '',
    style = {},
    showTooltip = false,
    showDuration = false,
    showPopular = false
}) => {
    const subcategoryInfo = getSubcategoryInfo(subcategoryName);

    // Size mapping
    const sizeClasses = {
        sm: 'w-8 h-8',
        md: 'w-12 h-12',
        lg: 'w-16 h-16',
        xl: 'w-20 h-20'
    };

    const iconSizeClasses = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16'
    };

    const containerClasses = `${sizeClasses[size]} ${className}`;
    const iconClasses = iconSizeClasses[size];

    return (
        <div className="relative">
            <div
                className={`flex items-center justify-center rounded-lg ${containerClasses}`}


            >
                <Image
                    src={subcategoryInfo.icon}
                    alt={subcategoryInfo.displayName}
                    className={`${iconClasses} object-contain`}
                    height={38}
                    width={38}
                />
            </div>

           
           
        </div>
    );
};

export default SubcategoryIcon; 